import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  columnContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  container_button: {
    display: 'flex',
    alignItems: 'center',
  },
}));
